module.exports = __webpack_public_path__ + "img/arrow-right-black.088a0a0c.svg";